/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DispositionSagasVehicleLogQueryVariables = {
    delivery: boolean;
    pickupPlanned: boolean;
    pickupConfirmed: boolean;
    fromStation: boolean;
    toStation: boolean;
    startdate: string;
    enddate: string;
    station: string;
    region: string;
    allStations: boolean;
    user: string;
    withoutDelivered?: boolean | null | undefined;
};
export type DispositionSagasVehicleLogQueryResponse = {
    readonly vehicleLogList: {
        readonly vehicleLogs: ReadonlyArray<{
            readonly status: string | null;
            readonly bookingId: number | null;
            readonly vehicleId: string | null;
            readonly licensePlate: string | null;
            readonly vehicleName: string | null;
            readonly stationId: string | null;
            readonly mileage: number | null;
            readonly mileageTarget: number | null;
            readonly startdate: string | null;
            readonly enddate: string | null;
            readonly vehicleGroup: string | null;
            readonly remark: string | null;
            readonly userRemark: string | null;
            readonly parkingArea: string | null;
            readonly equipment: string | null;
            readonly maxKm: number | null;
            readonly buybackAgreement: string | null;
            readonly position: string | null;
            readonly owner: string | null;
            readonly date: string | null;
            readonly type: string | null;
            readonly customerName: string | null;
            readonly customerStreet: string | null;
            readonly customerZipcode: string | null;
            readonly customerCity: string | null;
            readonly remark1: string | null;
            readonly remark2: string | null;
            readonly customerId: number | null;
            readonly agentName: string | null;
            readonly agentStreet: string | null;
            readonly agentCity: string | null;
            readonly agentZipcode: string | null;
            readonly isRentable: boolean | null;
            readonly disponame: string | null;
            readonly vehicleStatus: string | null;
            readonly hasLetter: boolean | null;
            readonly vehicleDelivered: string | null;
            readonly licenseOrdered: string | null;
            readonly orderId: string | null;
            readonly lastTenant: number | null;
            readonly workshopVehicle: boolean | null;
            readonly workshopVehicleFrom: string | null;
            readonly workshopVehicleTo: string | null;
            readonly deliveryName1: string | null;
            readonly deliveryName2: string | null;
            readonly deliveryStreet: string | null;
            readonly deliveryZipcode: string | null;
            readonly deliveryCity: string | null;
            readonly deliveryPhone: string | null;
            readonly deliveryDate: string | null;
            readonly pickupName1: string | null;
            readonly pickupName2: string | null;
            readonly pickupStreet: string | null;
            readonly pickupZipcode: string | null;
            readonly pickupCity: string | null;
            readonly pickupPhone: string | null;
            readonly pickupDate: string | null;
            readonly alternateGroups: string | null;
            readonly color: string | null;
            readonly availableUntil: string | null;
            readonly unladenWeight: number | null;
            readonly totalWeight: number | null;
            readonly insideHeight: number | null;
            readonly insideWidth: number | null;
            readonly insideLength: number | null;
            readonly wizMaxKm: number | null;
            readonly reservationStartdate: string | null;
            readonly reservationEnddate: string | null;
            readonly reservationPlannedEnddate: string | null;
            readonly contractColor: string | null;
            readonly dispoColor: string | null;
            readonly driver1: {
                readonly firstname: string | null;
                readonly lastname: string | null;
            } | null;
            readonly customer: {
                readonly customerId: string | null;
                readonly name1: string | null;
            } | null;
            readonly plannedVehicleGroup: {
                readonly vehicleGroupId: string;
                readonly description: string | null;
            } | null;
            readonly reservationNumber: string | null;
            readonly rate: string | null;
            readonly tripsBefore: ReadonlyArray<{
                readonly bookingId: string;
                readonly startdate: string | null;
                readonly enddate: string | null;
                readonly plannedEnddate: string | null;
                readonly vehicleGroup: {
                    readonly vehicleGroupId: string;
                    readonly description: string | null;
                } | null;
                readonly plannedVehicleGroup: {
                    readonly vehicleGroupId: string;
                    readonly description: string | null;
                } | null;
                readonly startstation: {
                    readonly stationId: string | null;
                } | null;
                readonly endstation: {
                    readonly stationId: string | null;
                } | null;
                readonly plannedEndstation: {
                    readonly stationId: string | null;
                } | null;
                readonly isSearchResult: boolean | null;
                readonly contractColor: string | null;
                readonly frameColor: string | null;
                readonly customer: {
                    readonly customerId: string | null;
                    readonly name1: string | null;
                } | null;
                readonly reservationNumber: string | null;
                readonly pickupDate: string | null;
                readonly deliveryDate: string | null;
                readonly driver1: {
                    readonly firstname: string | null;
                    readonly lastname: string | null;
                } | null;
                readonly rate: string | null;
            } | null> | null;
            readonly tripsAfter: ReadonlyArray<{
                readonly bookingId: string;
                readonly startdate: string | null;
                readonly enddate: string | null;
                readonly plannedEnddate: string | null;
                readonly vehicleGroup: {
                    readonly vehicleGroupId: string;
                    readonly description: string | null;
                } | null;
                readonly plannedVehicleGroup: {
                    readonly vehicleGroupId: string;
                    readonly description: string | null;
                } | null;
                readonly startstation: {
                    readonly stationId: string | null;
                } | null;
                readonly endstation: {
                    readonly stationId: string | null;
                } | null;
                readonly plannedEndstation: {
                    readonly stationId: string | null;
                } | null;
                readonly isSearchResult: boolean | null;
                readonly contractColor: string | null;
                readonly frameColor: string | null;
                readonly customer: {
                    readonly customerId: string | null;
                    readonly name1: string | null;
                } | null;
                readonly reservationNumber: string | null;
                readonly pickupDate: string | null;
                readonly deliveryDate: string | null;
                readonly driver1: {
                    readonly firstname: string | null;
                    readonly lastname: string | null;
                } | null;
                readonly rate: string | null;
            } | null> | null;
        } | null> | null;
    } | null;
};
export type DispositionSagasVehicleLogQuery = {
    readonly response: DispositionSagasVehicleLogQueryResponse;
    readonly variables: DispositionSagasVehicleLogQueryVariables;
};



/*
query DispositionSagasVehicleLogQuery(
  $delivery: Boolean!
  $pickupPlanned: Boolean!
  $pickupConfirmed: Boolean!
  $fromStation: Boolean!
  $toStation: Boolean!
  $startdate: String!
  $enddate: String!
  $station: String!
  $region: String!
  $allStations: Boolean!
  $user: String!
  $withoutDelivered: Boolean
) {
  vehicleLogList(delivery: $delivery, pickupPlanned: $pickupPlanned, pickupConfirmed: $pickupConfirmed, fromStation: $fromStation, toStation: $toStation, startdate: $startdate, enddate: $enddate, station: $station, region: $region, allStations: $allStations, user: $user, withoutDelivered: $withoutDelivered) {
    vehicleLogs {
      status
      bookingId
      vehicleId
      licensePlate
      vehicleName
      stationId
      mileage
      mileageTarget
      startdate
      enddate
      vehicleGroup
      remark
      userRemark
      parkingArea
      equipment
      maxKm
      buybackAgreement
      position
      owner
      date
      type
      customerName
      customerStreet
      customerZipcode
      customerCity
      remark1
      remark2
      customerId
      agentName
      agentStreet
      agentCity
      agentZipcode
      isRentable
      disponame
      vehicleStatus
      hasLetter
      vehicleDelivered
      licenseOrdered
      orderId
      lastTenant
      workshopVehicle
      workshopVehicleFrom
      workshopVehicleTo
      deliveryName1
      deliveryName2
      deliveryStreet
      deliveryZipcode
      deliveryCity
      deliveryPhone
      deliveryDate
      pickupName1
      pickupName2
      pickupStreet
      pickupZipcode
      pickupCity
      pickupPhone
      pickupDate
      alternateGroups
      color
      availableUntil
      unladenWeight
      totalWeight
      insideHeight
      insideWidth
      insideLength
      wizMaxKm
      reservationStartdate
      reservationEnddate
      reservationPlannedEnddate
      contractColor
      dispoColor
      driver1 {
        firstname
        lastname
      }
      customer {
        customerId
        name1
      }
      plannedVehicleGroup {
        vehicleGroupId
        description
      }
      reservationNumber
      rate
      tripsBefore {
        bookingId
        startdate
        enddate
        plannedEnddate
        vehicleGroup {
          vehicleGroupId
          description
        }
        plannedVehicleGroup {
          vehicleGroupId
          description
        }
        startstation {
          stationId
        }
        endstation {
          stationId
        }
        plannedEndstation {
          stationId
        }
        isSearchResult
        contractColor
        frameColor
        customer {
          customerId
          name1
        }
        reservationNumber
        pickupDate
        deliveryDate
        driver1 {
          firstname
          lastname
        }
        rate
      }
      tripsAfter {
        bookingId
        startdate
        enddate
        plannedEnddate
        vehicleGroup {
          vehicleGroupId
          description
        }
        plannedVehicleGroup {
          vehicleGroupId
          description
        }
        startstation {
          stationId
        }
        endstation {
          stationId
        }
        plannedEndstation {
          stationId
        }
        isSearchResult
        contractColor
        frameColor
        customer {
          customerId
          name1
        }
        reservationNumber
        pickupDate
        deliveryDate
        driver1 {
          firstname
          lastname
        }
        rate
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "allStations"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "delivery"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "enddate"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fromStation"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pickupConfirmed"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pickupPlanned"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "region"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startdate"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "station"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "toStation"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "user"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "withoutDelivered"
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bookingId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stationId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startdate",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enddate",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customerId",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deliveryDate",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pickupDate",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contractColor",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "Driver",
  "kind": "LinkedField",
  "name": "driver1",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstname",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastname",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "Customer",
  "kind": "LinkedField",
  "name": "customer",
  "plural": false,
  "selections": [
    (v16/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name1",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v22 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "vehicleGroupId",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }
],
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "VehicleGroup",
  "kind": "LinkedField",
  "name": "plannedVehicleGroup",
  "plural": false,
  "selections": (v22/*: any*/),
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reservationNumber",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rate",
  "storageKey": null
},
v26 = [
  (v13/*: any*/)
],
v27 = [
  (v12/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "plannedEnddate",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "VehicleGroup",
    "kind": "LinkedField",
    "name": "vehicleGroup",
    "plural": false,
    "selections": (v22/*: any*/),
    "storageKey": null
  },
  (v23/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Station",
    "kind": "LinkedField",
    "name": "startstation",
    "plural": false,
    "selections": (v26/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Station",
    "kind": "LinkedField",
    "name": "endstation",
    "plural": false,
    "selections": (v26/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Station",
    "kind": "LinkedField",
    "name": "plannedEndstation",
    "plural": false,
    "selections": (v26/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isSearchResult",
    "storageKey": null
  },
  (v19/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "frameColor",
    "storageKey": null
  },
  (v21/*: any*/),
  (v24/*: any*/),
  (v18/*: any*/),
  (v17/*: any*/),
  (v20/*: any*/),
  (v25/*: any*/)
],
v28 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "allStations",
        "variableName": "allStations"
      },
      {
        "kind": "Variable",
        "name": "delivery",
        "variableName": "delivery"
      },
      {
        "kind": "Variable",
        "name": "enddate",
        "variableName": "enddate"
      },
      {
        "kind": "Variable",
        "name": "fromStation",
        "variableName": "fromStation"
      },
      {
        "kind": "Variable",
        "name": "pickupConfirmed",
        "variableName": "pickupConfirmed"
      },
      {
        "kind": "Variable",
        "name": "pickupPlanned",
        "variableName": "pickupPlanned"
      },
      {
        "kind": "Variable",
        "name": "region",
        "variableName": "region"
      },
      {
        "kind": "Variable",
        "name": "startdate",
        "variableName": "startdate"
      },
      {
        "kind": "Variable",
        "name": "station",
        "variableName": "station"
      },
      {
        "kind": "Variable",
        "name": "toStation",
        "variableName": "toStation"
      },
      {
        "kind": "Variable",
        "name": "user",
        "variableName": "user"
      },
      {
        "kind": "Variable",
        "name": "withoutDelivered",
        "variableName": "withoutDelivered"
      }
    ],
    "concreteType": "VehicleLogList",
    "kind": "LinkedField",
    "name": "vehicleLogList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "VehicleLog",
        "kind": "LinkedField",
        "name": "vehicleLogs",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vehicleId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "licensePlate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vehicleName",
            "storageKey": null
          },
          (v13/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mileage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "mileageTarget",
            "storageKey": null
          },
          (v14/*: any*/),
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vehicleGroup",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "remark",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userRemark",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "parkingArea",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "equipment",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "maxKm",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "buybackAgreement",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "position",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "owner",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "date",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerStreet",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerZipcode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerCity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "remark1",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "remark2",
            "storageKey": null
          },
          (v16/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "agentName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "agentStreet",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "agentCity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "agentZipcode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isRentable",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "disponame",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vehicleStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasLetter",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vehicleDelivered",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "licenseOrdered",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "orderId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastTenant",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workshopVehicle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workshopVehicleFrom",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workshopVehicleTo",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deliveryName1",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deliveryName2",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deliveryStreet",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deliveryZipcode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deliveryCity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deliveryPhone",
            "storageKey": null
          },
          (v17/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pickupName1",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pickupName2",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pickupStreet",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pickupZipcode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pickupCity",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pickupPhone",
            "storageKey": null
          },
          (v18/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "alternateGroups",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "color",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "availableUntil",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unladenWeight",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalWeight",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "insideHeight",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "insideWidth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "insideLength",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "wizMaxKm",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reservationStartdate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reservationEnddate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reservationPlannedEnddate",
            "storageKey": null
          },
          (v19/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dispoColor",
            "storageKey": null
          },
          (v20/*: any*/),
          (v21/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Booking",
            "kind": "LinkedField",
            "name": "tripsBefore",
            "plural": true,
            "selections": (v27/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Booking",
            "kind": "LinkedField",
            "name": "tripsAfter",
            "plural": true,
            "selections": (v27/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DispositionSagasVehicleLogQuery",
    "selections": (v28/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v9/*: any*/),
      (v7/*: any*/),
      (v2/*: any*/),
      (v8/*: any*/),
      (v6/*: any*/),
      (v0/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/)
    ],
    "kind": "Operation",
    "name": "DispositionSagasVehicleLogQuery",
    "selections": (v28/*: any*/)
  },
  "params": {
    "cacheID": "76f0b3a4b2b5eff5c8127dd0fbb1cfd2",
    "id": null,
    "metadata": {},
    "name": "DispositionSagasVehicleLogQuery",
    "operationKind": "query",
    "text": "query DispositionSagasVehicleLogQuery(\n  $delivery: Boolean!\n  $pickupPlanned: Boolean!\n  $pickupConfirmed: Boolean!\n  $fromStation: Boolean!\n  $toStation: Boolean!\n  $startdate: String!\n  $enddate: String!\n  $station: String!\n  $region: String!\n  $allStations: Boolean!\n  $user: String!\n  $withoutDelivered: Boolean\n) {\n  vehicleLogList(delivery: $delivery, pickupPlanned: $pickupPlanned, pickupConfirmed: $pickupConfirmed, fromStation: $fromStation, toStation: $toStation, startdate: $startdate, enddate: $enddate, station: $station, region: $region, allStations: $allStations, user: $user, withoutDelivered: $withoutDelivered) {\n    vehicleLogs {\n      status\n      bookingId\n      vehicleId\n      licensePlate\n      vehicleName\n      stationId\n      mileage\n      mileageTarget\n      startdate\n      enddate\n      vehicleGroup\n      remark\n      userRemark\n      parkingArea\n      equipment\n      maxKm\n      buybackAgreement\n      position\n      owner\n      date\n      type\n      customerName\n      customerStreet\n      customerZipcode\n      customerCity\n      remark1\n      remark2\n      customerId\n      agentName\n      agentStreet\n      agentCity\n      agentZipcode\n      isRentable\n      disponame\n      vehicleStatus\n      hasLetter\n      vehicleDelivered\n      licenseOrdered\n      orderId\n      lastTenant\n      workshopVehicle\n      workshopVehicleFrom\n      workshopVehicleTo\n      deliveryName1\n      deliveryName2\n      deliveryStreet\n      deliveryZipcode\n      deliveryCity\n      deliveryPhone\n      deliveryDate\n      pickupName1\n      pickupName2\n      pickupStreet\n      pickupZipcode\n      pickupCity\n      pickupPhone\n      pickupDate\n      alternateGroups\n      color\n      availableUntil\n      unladenWeight\n      totalWeight\n      insideHeight\n      insideWidth\n      insideLength\n      wizMaxKm\n      reservationStartdate\n      reservationEnddate\n      reservationPlannedEnddate\n      contractColor\n      dispoColor\n      driver1 {\n        firstname\n        lastname\n      }\n      customer {\n        customerId\n        name1\n      }\n      plannedVehicleGroup {\n        vehicleGroupId\n        description\n      }\n      reservationNumber\n      rate\n      tripsBefore {\n        bookingId\n        startdate\n        enddate\n        plannedEnddate\n        vehicleGroup {\n          vehicleGroupId\n          description\n        }\n        plannedVehicleGroup {\n          vehicleGroupId\n          description\n        }\n        startstation {\n          stationId\n        }\n        endstation {\n          stationId\n        }\n        plannedEndstation {\n          stationId\n        }\n        isSearchResult\n        contractColor\n        frameColor\n        customer {\n          customerId\n          name1\n        }\n        reservationNumber\n        pickupDate\n        deliveryDate\n        driver1 {\n          firstname\n          lastname\n        }\n        rate\n      }\n      tripsAfter {\n        bookingId\n        startdate\n        enddate\n        plannedEnddate\n        vehicleGroup {\n          vehicleGroupId\n          description\n        }\n        plannedVehicleGroup {\n          vehicleGroupId\n          description\n        }\n        startstation {\n          stationId\n        }\n        endstation {\n          stationId\n        }\n        plannedEndstation {\n          stationId\n        }\n        isSearchResult\n        contractColor\n        frameColor\n        customer {\n          customerId\n          name1\n        }\n        reservationNumber\n        pickupDate\n        deliveryDate\n        driver1 {\n          firstname\n          lastname\n        }\n        rate\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'cfe863dfdb5e64f47440f4f166be2bf9';
export default node;
